import axios from "axios";
import { apiHttp } from "@/api/index";
// const baseUrl = process.env.VUE_APP_BASE_URL; //测试
// const baseUrl = "http://192.168.31.93:8888"; //测试
const baseUrlFile = process.env.VUE_APP_BASE_FILE_URL; // 上传文件

axios.defaults.timeout = 0;
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (data) => {
    return data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const getUrl = (url) => {
  const str = url.split("/")[1];
  switch (str) {
    case "sys":
    case "ums":
      break;
    case "quatrust":
      url = "/owltrust" + url;
      break;
    default:
      url = "/signtrust" + url;
      break;
  }
  return url;
};

// 普通的post封装
export function post(url, params = {}) {
  return apiHttp.post(getUrl(url), params);
  // return new Promise<T>((resolve, reject) => {
  //   axios
  //     .post<T>(`${baseUrl}${url}`, params)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         resolve(res.data);
  //       }
  //     })
  //     .catch((err) => reject(err));
  // });
}

// 携带token的post封装
export function postWithToken(url, params: any = {}) {
  params.token = localStorage.token;
  params.usrId = localStorage.userId;
  params.clientplatformId = 0;
  params.usrPhone = localStorage.userPhone;
  return apiHttp.post(getUrl(url), params) as any;
  // return new Promise<T>((resolve, reject) => {
  //   axios
  //     .post<T>(`${baseUrl}${url}`, {
  //       ...params,
  //       clientplatformId: 0,
  //       token: store.getters.getToken,
  //     })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         resolve(res.data);
  //       }
  //     })
  //     .catch((err) => reject(err));
  // });
}

// 文件上传的相关API
export function postFile<T = any>(url, params, formType = false) {
  const formDataConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return new Promise<T>((resolve, reject) => {
    axios
      .post<T>(`${baseUrlFile}${url}`, params, formType ? formDataConfig : {})
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data);
        }
      })
      .catch((err) => reject(err));
  });
}

// 文件上传的相关API
export function getRequestFile<T = any>(url, params?) {
  return new Promise<T>((resolve, reject) => {
    axios
      .get<T>(`${baseUrlFile}${url}`, { params })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data);
        }
      })
      .catch((err) => reject(err));
  });
}
